/*
 * @Author: 王新
 * @Date: 2021-04-22 09:29:12
 * @FilePath: \operation-screen\src\router\route_1.js
 * @Description: 路由的映射文件
 */
import Home from "../views/homePage/homePage.vue";
import Demo from "../views/Demo/Demo.vue";
import orgTeam from "../views/orgTeam/orgTeam.vue";
import govDetail from "../views/govDetail/govDetail.vue";
import govCont from "../views/govCont/govCont.vue";
import socialorgDetails from "../views/socialorgDetails/socialorgDetails.vue";
import projectDetails from "../views/projectDetails/projectDetails.vue";
import activityDetails from "../views/activityDetails/activityDetails.vue";
import PersonNeedList from "../views/personNeedList/index.vue"
import demandDetails from "../views/demandDetails/demandDetails.vue";
const routes = [{
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/Demo",
        name: "Demo",
        component: Demo,
    },
    {
        path: '/demand',
        component: () =>
            import ('../views/demand/list')
    },
    {
        path: '/project',
        component: () =>
            import ('../views/project/project')
    },
    {
        path: '/servers',
        component: () =>
            import ('../views/servers/servers')
    },
    {
        path: '/league',
        component: () =>
            import ('../views/league/league')
    },
    {
        path: "/orgTeam",
        name: "orgTeam",
        component: orgTeam,
    },
    {
        path: "/govDetail",
        name: "govDetail",
        component: govDetail,
    },
    {
        path: "/socialorgDetails",
        name: "socialorgDetails",
        component: socialorgDetails,
    },
    {
        path: "/projectDetails",
        name: "projectDetails",
        component: projectDetails,
    },
    {
        path: "/activityDetails",
        name: "activityDetails",
        component: activityDetails,
    },
    {
        path: "/govCont",
        name: "govCont",
        component: govCont,
    },
    {
        path: "/personneedlist",
        name: "personneedlist",
        component: PersonNeedList
    },
    // 详情
    {
        path: "/demandDetails",
        name: "demandDetails",
        component: demandDetails,
    },
];
export default routes;